import {
  EnvironmentProviders,
  inject,
  isDevMode,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';

import { TranslocoHttpLoader } from './transloco-loader';
import { LanguageService } from './language.service';

/**
 * provideI18n — one call to wire Transloco + the HTTP/JSON loader + da/en, and
 * apply the detected/persisted language at bootstrap (pre-first-paint). Drop it
 * into each public SPA's `app.config.ts` providers. Story 25.5.
 */
export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTransloco({
      config: {
        availableLangs: ['da', 'en'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    // Apply the detected/persisted language before the first paint so the app
    // renders in the right language immediately (no flash of the default lang).
    provideAppInitializer(() => {
      inject(TranslocoService).setActiveLang(inject(LanguageService).detect());
    }),
  ]);
}
